import React from 'react';
import './blog-post.css';
import equity1 from './pictures/equity1.jpg';
import equity2 from './pictures/equity2.jpg';



//import reportWebVitals from './reportWebVitals';

const Equity23 = () => {

  return (
    <div>
      <div className='blog__container'>
        <div className="row">
            <div className="column">
                <header>
                    <h3 className="site-post-title rounded title-padding">
                        <b>WiC at Work</b>
                    </h3>
                </header>
                <section>
                    <h2>Racial Equity in Tech Event Recap</h2>
                    <p className="site-post-meta">January 23, 2023</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                        On January 17th, we held our Racial Equity in tech event in collaboration with Minorities in Tech! 
                        We heard from our amazing panel of speakers that consisted of members of the Allen School:  Jan Cuny 
                        (Director of DEIA for Strategy & Operations), Lauren Bricker (working with STARS and Startup programs, 
                        Code.org.), Kevin Lin (Assistant Teaching Professor), Leilani Battle (Assistant Professor), and 
                        Hannah Tang (Professor)! We heard speakers share their inspiring experiences, their journeys, and work
                        they’ve done to promote racial equity in tech over a delicious catered dinner. We heard about racial 
                        and gender diversity in tech, both in industry and in academia. Some major takeaways were a better 
                        understanding of how the lack of diversity in tech impacts the products and services that are developed 
                        and what can be done to ensure that the needs and perspectives of diverse communities are considered 
                        in the development process. In addition, we also learned more about what work is being done within 
                        the Allen School to increase diversity and where we can improve as a department! Speakers and attendees 
                        also enjoyed a networking break with lively conversations and time to make friends! Thank you so much 
                        to everyone who was able to make it, we appreciate your vulnerability and participation in our event. 
                        We will have more events such as this one in the future and we can’t wait to see you there! 
                    </p>
                    <img src={equity1} alt="Women in Computing members with Speakers"/>
                    <img src={equity2} alt="Speakers"/>
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default Equity23;